module.exports = __webpack_public_path__ + "img/yoimiya.3898271e.webp";